import React, { useState } from "react";
import { Box, Grid, Stack, TextField, Typography } from "@mui/material";
import PointOfSaleRoundedIcon from "@mui/icons-material/PointOfSaleRounded";
import StorefrontRoundedIcon from "@mui/icons-material/StorefrontRounded";
import GroupsRoundedIcon from "@mui/icons-material/GroupsRounded";
import DynamicList from "../pieces/DynamicList";
import CommissariesEditor from "../pieces/CommissariesEditor";

const sectionTitleSx = {
  fontWeight: 900,
  fontSize: "1rem",
  color: "rgba(255,255,255,0.94)",
  mb: 0.45,
};

const sectionSubSx = {
  fontSize: "0.84rem",
  color: "rgba(255,255,255,0.5)",
  mb: 2,
  lineHeight: 1.6,
};

const inputSx = {
  "& .MuiOutlinedInput-root": {
    borderRadius: "16px",
    backgroundColor: "rgba(255,255,255,0.03)",
    transition: "all 0.2s ease-in-out",
    "& fieldset": { borderColor: "rgba(255,255,255,0.12)" },
    "&:hover fieldset": { borderColor: "rgba(255,255,255,0.24)" },
    "&.Mui-focused": {
      backgroundColor: "rgba(255,255,255,0.05)",
      "& fieldset": { borderColor: "rgba(0,225,255,0.55)" },
    },
  },
  "& .MuiInputLabel-root": { color: "rgba(255,255,255,0.58)" },
  "& .MuiInputBase-input": { color: "#fff" },
};

const blockSx = {
  p: { xs: 1.4, md: 1.8 },
  borderRadius: 2,
  border: "1px solid rgba(255,255,255,0.08)",
  bgcolor: "rgba(255,255,255,0.025)",
};

function SectionIntro({ icon, title, subtitle }) {
  return (
    <Stack spacing={1.25} sx={{ mb: 2 }}>
      <Stack direction="row" spacing={1.1} alignItems="center">
        <Box
          sx={{
            width: 38,
            height: 38,
            borderRadius: 2,
            display: "grid",
            placeItems: "center",
            bgcolor: "rgba(0,225,255,0.12)",
            color: "#8ef4ff",
          }}
        >
          {icon}
        </Box>
        <Box>
          <Typography sx={sectionTitleSx}>{title}</Typography>
          <Typography sx={sectionSubSx}>{subtitle}</Typography>
        </Box>
      </Stack>
    </Stack>
  );
}

export default function VendasStep({ state, actions }) {
  const [pointInput, setPointInput] = useState("");

  return (
    <Stack spacing={2}>
      <Box sx={blockSx}>
        <SectionIntro
          icon={<PointOfSaleRoundedIcon sx={{ fontSize: 20 }} />}
          title="Configurações de venda"
          subtitle="Defina limite de compra por usuário e a taxa de serviço usada no evento."
        />

        <Grid container spacing={1.6}>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              type="number"
              label="Limite de ingressos por usuário"
              value={state.vendas.limitePorUsuario}
              onChange={(e) =>
                actions.set(
                  "vendas.limitePorUsuario",
                  Math.max(1, Number(e.target.value || 1)),
                )
              }
              helperText="Ex: 2 ingressos por CPF."
              sx={inputSx}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              type="number"
              label="Taxa de Serviço (%)"
              value={state.vendas.taxaOnurbPercent}
              onChange={(e) =>
                actions.set(
                  "vendas.taxaOnurbPercent",
                  Math.max(0, Number(e.target.value || 0)),
                )
              }
              helperText="Porcentagem cobrada em cima do valor do ingresso."
              sx={inputSx}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
        </Grid>
      </Box>

      <Box sx={blockSx}>
        <SectionIntro
          icon={<StorefrontRoundedIcon sx={{ fontSize: 20 }} />}
          title="Pontos de venda físicos"
          subtitle="Cadastre locais presenciais caso o público possa comprar ingressos fora do site."
        />

        <DynamicList
          placeholder="Ex: Bilheteria do Clube, Loja do Centro..."
          value={pointInput}
          onChange={setPointInput}
          items={state.vendas.pontosFisicos}
          onAdd={() => {
            if (!pointInput.trim()) return;
            actions.addPoint(pointInput.trim());
            setPointInput("");
          }}
          onRemove={(idx) => actions.removePoint(idx)}
        />
      </Box>

      <Box sx={blockSx}>
        <SectionIntro
          icon={<GroupsRoundedIcon sx={{ fontSize: 20 }} />}
          title="Comissários oficiais"
          subtitle="Cadastre promoters ou vendedores autorizados com nome e telefone."
        />

        <CommissariesEditor
          commissaries={state.vendas.comissarios}
          onAdd={actions.addCommissary}
          onChange={(id, patch) => actions.updateCommissary(id, patch)}
          onRemove={(id) => actions.removeCommissary(id)}
        />
      </Box>
    </Stack>
  );
}
